/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsSmallCenteredParagraphViewProps } from '../../../modules/hosports-small-centered-paragraph/./hosports-small-centered-paragraph';
import ScrollFadeIn from '../../../baseComponents/scroll-fade/./scroll-fade';

class HosportsSmallCenteredParagraph extends React.Component<IHosportsSmallCenteredParagraphViewProps> {
  public render(): JSX.Element {
    const { config } = this.props;
    let alignmentClass:any = 'centered-text';
    if(config.alignment === "left"){
      alignmentClass = 'left-text'
    }
    if(config.alignment === "right"){
      alignmentClass = 'right-text'
    }
    return (
      <ScrollFadeIn>
        <div className="small-padding">
          <div className={alignmentClass+` hosports-centered-paragraph-description-container small-max-width-container`}>
            {config.title && <h4 className="hosports-centered-paragraph-title">{config.title}</h4>}
            {config.description && <p className="hosports-centered-paragraph-description subheading">{config.description}</p>}
          </div>
        </div>
      </ScrollFadeIn>
    );
  }
}

export default HosportsSmallCenteredParagraph;
